/* src/lessons/cards/LessonCard/styles.js */

export default theme => ({
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '75%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  formControl: {
    margin: theme.spacing.unit,
    marginBottom: 0,
    maxWidth: 200,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: theme.spacing.unit * 4,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing.unit * 4,
    paddingTop: 0,
    alignItems: 'flex-end',
    flexGrow: 1,
  },
  charge: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
});



// WEBPACK FOOTER //
// ./src/modules/lessons/cards/LessonCard/styles.js